import { render, staticRenderFns } from "./Timer.vue?vue&type=template&id=d1603c34&scoped=true&lang=pug&"
import script from "./Timer.vue?vue&type=script&lang=js&"
export * from "./Timer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1603c34",
  null
  
)

export default component.exports